import axios from "@/plugins/axios";
import { getApiUrl } from "@/services/_apiUrl";

const apiUrl = getApiUrl();

export function fetchCsvExports(params = {}) {
  return axios.get(apiUrl.submissionExports.GET.LIST, { params });
}

export function fetchCsvExportDownloadUrl(exportId) {
  const url = apiUrl.submissionExports.GET.DOWNLOAD.replace("{exportId}", exportId);
  return axios.get(url);
}

export function createCsvExport(filters = {}) {
  // String fields should remain as strings (not wrapped in arrays)
  const stringFields = [
    "date_from",
    "date_to",
    "product_group",
    "file_name",
    "id",
    "email",
    "teams_tenant_id",
    "meeting_id",
  ];
  // Fields that should be excluded from the export API request
  const excludedFields = ["wide_search"];

  const normalizedFilters = Object.entries(filters).reduce((acc, [key, value]) => {
    if (value === null || value === undefined || value === "") {
      return acc;
    }
    if (excludedFields.includes(key)) {
      return acc;
    }
    if (stringFields.includes(key)) {
      acc[key] = value;
    } else if (Array.isArray(value)) {
      acc[key] = value;
    } else if (typeof value === "string" && value.includes(`&${key}=`)) {
      // Parse URL-encoded format like "value1&key=value2" back to array
      acc[key] = value.split(`&${key}=`);
    } else {
      acc[key] = [value];
    }
    return acc;
  }, {});

  return axios.post(apiUrl.submissionExports.POST, { filters: normalizedFilters });
}
